<script lang="ts" generics="T extends any">
  import api from '../api/api'
  import type {Pagination} from '../types'
  import {debounce} from '../utils/debounce'

  export let items: T[] | undefined
  export let url: string
  export let per = 12
  export let search: string | undefined = undefined
  export let order = ''

  export let pagination: Pagination = {page: 0} as Pagination

  async function loadNext(reset = false) {
    if (reset) pagination.page = 0
    const connectSymbol = url.includes('?') ? '&' : '?'
    let paginatedUrl = `${url}${connectSymbol}page=${pagination.page + 1}&per=${per}`
    if (search) paginatedUrl = paginatedUrl + `&query=${encodeURIComponent(search)}`
    if (order) paginatedUrl = paginatedUrl + `&order=${order}`
    const response = await api.getWithPagination<T[]>(paginatedUrl)
    pagination = response.pagination
    items = reset ? response.items : [...(items || []), ...response.items]
  }

  const debouncedLoadNext = debounce(loadNext, 100)

  $: (search || order || url) && debouncedLoadNext(true)
  $: remaining = pagination.total - (pagination.page * pagination.per)
</script>

{#if pagination.pages > pagination.page}
  <slot {loadNext} {remaining}/>
{/if}